import { ConditionBinding } from '@retail/calculus/types';

export enum EnteredField {
  FACTOR = 'FACTOR',
  PERCENT = 'PERCENT',
}

export interface CustomerMarkupConditionsPost {
  customerMarkup: {
    percent?: number;
    factor?: number;
  };
  binding: ConditionBinding | ConditionBinding[];
  validFrom: string;
  validTo?: string;
}
